import Avatar from 'ui/atoms/Avatar/Avatar';
import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import Icon from 'ui/atoms/Icon/Icon';
import InputText from 'ui/atoms/InputText/InputText';
import FormField from 'ui/molecules/FormField/FormField';
import PropTypes from 'prop-types';
import React from 'react';
import { useDialogSendNewVersion } from './useDialogSendNewVersion';

const DialogSendNewVersion = ({ open, onClose, onSuccess, students, noteTotal }) => {
  const { t, comment, onChangeComment, onConfirm } = useDialogSendNewVersion({ onSuccess, open });

  return (
    <Dialog
      title={t('assigments:Send new version')}
      isOpen={open}
      onClose={onClose}
      onCancel={onClose}
      onSuccess={onConfirm}
      buttonTextSuccess={t('assigments:Send new version')}
      buttonTextCancel={t('actions:Cancel')}
      size="m"
      className="dialog-send-new-version"
    >
      <p className="dialog-send-new-version__description">{t('assigments:Send new version description')}</p>
      <ul className="dialog-send-new-version__students-list">
        {students.map((student) => (
          <li className="dialog-send-new-version__student-cell" key={student.student_guid || student.person_guid}>
            <Icon name="exclamation-filled" size="md" />
            <Avatar image={student.avatar} />
            <span className="dialog-send-new-version__student-name">{student.student_name} {student.student_lastname}</span>
            <div className="dialog-send-new-version__grade">
              <span className="dialog-send-new-version__grade-score">{student.score ?? '-'}</span>
              <span className="dialog-send-new-version__grade-total">/{noteTotal}</span>
            </div>
          </li>
        ))}
      </ul>
      <FormField isLabelHidden label={t('assigments:Add private comment')}>
        <InputText placeholder={t('assigments:Add private comment')} value={comment} onChange={onChangeComment} />
      </FormField>
    </Dialog>
  );
};

DialogSendNewVersion.propTypes = {
  noteTotal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  open: PropTypes.bool,
  students: PropTypes.array,
};

DialogSendNewVersion.defaultProps = {
  onClose: function () {},
  onSuccess: function () {},
  open: false,
  students: [],
};

export default DialogSendNewVersion;
